import IBAConsoleLayout from "Layout/IBAConsoleLayout";
import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import RadioGroup from "@amzn/awsui-components-react/polaris/radio-group";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import React from "react";
import OfferConfigurationPage from "./offerConfigurationPage";
import MerchantConfigurationPage from "./merchantConfigurationPage";

const OFFER_OPTION = "offer";
const MERCHANT_OPTION = "merchant";
const IBA_CONFIGURATION_OPTIONS = [
  { label: "Offer", value: OFFER_OPTION },
  { label: "Merchant", value: MERCHANT_OPTION },
];

const SellerIBAConfigurationPage = () => {
  const [configurationType, setConfigurationType] = React.useState(OFFER_OPTION);

  return (
    <IBAConsoleLayout>
      <SpaceBetween direction="vertical" size="xxl">
        <Header variant="h1">Enable Seller IBA Configuration</Header>

        <Container header={<Header variant="h2">Configuration Type</Header>}>
          <RadioGroup
            items={IBA_CONFIGURATION_OPTIONS}
            onChange={({ detail }) => setConfigurationType(detail.value)}
            value={configurationType}
          />
        </Container>

        {configurationType === OFFER_OPTION && <OfferConfigurationPage />}
        {configurationType === MERCHANT_OPTION && <MerchantConfigurationPage />}
      </SpaceBetween>
    </IBAConsoleLayout>
  );
};

export default SellerIBAConfigurationPage;
